exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-expansion-panel__header {margin-left: 16px;\n}\n.v-input--slider {margin-bottom: 20px; margin-top: 0px !important;\n}\n/*.btn_copierBulleChat{margin:0; position: absolute; top: 12px; right: 6px;}*/\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/stats/AgentsPerformance.vue
// module id = jy8K
// module chunks = 1